import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const webSolutionSlice = createSlice({
    name: 'webSolution',
    initialState: null,
    reducers: {
        setWebSolution: (state, action) => {
            return action.payload;
        },
        resetWebSolution: () => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return null;
        });
    }
});

export const { setWebSolution, resetWebSolution } = webSolutionSlice.actions;

type WebSolution = {
    data?: {
        schedulerId?: string;
    };
};

type State = {
    webSolution?: WebSolution | null;
};

export const selectSchedulerId = (state: State): string | undefined =>
    state.webSolution?.data?.schedulerId;

export default webSolutionSlice.reducer;
